import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Download, ExternalLink, X } from "lucide-react";

const EVENTO = "cs-visor-archivo";

export const abrirVisor = (ruta, nombre) => window.dispatchEvent(new CustomEvent(EVENTO, { detail: { ruta, nombre } }));

export default function VisorArchivo() {
  const [archivo, setArchivo] = useState(null);
  const [blob, setBlob] = useState(null);

  useEffect(() => {
    const h = (e) => setArchivo(e.detail);
    window.addEventListener(EVENTO, h);
    return () => window.removeEventListener(EVENTO, h);
  }, []);

  useEffect(() => {
    if (!archivo) return undefined;
    let url = null;
    api.get(archivo.ruta, { responseType: "blob" })
      .then((res) => { url = URL.createObjectURL(res.data); setBlob({ url, tipo: res.data.type || "" }); })
      .catch(() => { toast.error("No se pudo abrir el archivo"); setArchivo(null); });
    return () => { if (url) URL.revokeObjectURL(url); setBlob(null); };
  }, [archivo]);

  const descargar = () => {
    const a = document.createElement("a");
    a.href = blob.url; a.download = archivo.nombre;
    document.body.appendChild(a); a.click(); a.remove();
  };
  const esImagen = blob?.tipo.startsWith("image/");

  return (
    <Dialog open={!!archivo} onOpenChange={(o) => !o && setArchivo(null)}>
      <DialogContent className="max-w-4xl max-h-[92dvh] flex flex-col [&>button.absolute]:hidden" data-testid="visor-archivo">
        <DialogHeader>
          <div className="flex justify-between items-center gap-2 flex-wrap">
            <div className="min-w-0">
              <DialogTitle className="truncate" data-testid="visor-archivo-nombre">{archivo?.nombre}</DialogTitle>
              <DialogDescription>Vista del archivo adjunto</DialogDescription>
            </div>
            <div className="flex gap-2">
              <Button variant="outline" size="sm" disabled={!blob} onClick={() => window.open(blob.url, "_blank")} data-testid="visor-archivo-abrir"><ExternalLink className="h-4 w-4 mr-2" />Abrir</Button>
              <Button variant="outline" size="sm" disabled={!blob} onClick={descargar} data-testid="visor-archivo-descargar"><Download className="h-4 w-4 mr-2" />Descargar</Button>
              <Button variant="outline" size="sm" onClick={() => setArchivo(null)} data-testid="visor-archivo-cerrar"><X className="h-4 w-4 mr-2" />Cerrar</Button>
            </div>
          </div>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-auto rounded-md border bg-slate-50 flex items-center justify-center">
          {!blob && <p className="text-sm text-muted-foreground py-12">Cargando archivo...</p>}
          {blob && esImagen && <img src={blob.url} alt={archivo?.nombre} className="max-w-full max-h-[75dvh] object-contain" data-testid="visor-archivo-imagen" />}
          {blob && !esImagen && <iframe src={blob.url} title={archivo?.nombre} className="w-full h-[75dvh] bg-white" data-testid="visor-archivo-pdf" />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
